import { render, staticRenderFns } from "./PlanetContainer.vue?vue&type=template&id=43d8dc34&scoped=true&"
import script from "./PlanetContainer.vue?vue&type=script&lang=js&"
export * from "./PlanetContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d8dc34",
  null
  
)

export default component.exports